// frontend/src/components/client/FuelRequestCard.jsx
import React from 'react';
import { Fuel, Calendar, MapPin, ChevronRight } from 'lucide-react';

const StatusBadge = ({ status }) => {
  const config = {
    pending: { label: 'Pending', color: 'bg-yellow-500/20 text-yellow-400' },
    approved: { label: 'Approved', color: 'bg-green-500/20 text-green-400' },
    completed: { label: 'Completed', color: 'bg-blue-500/20 text-blue-400' },
  };
  const { label, color } = config[status] || config.pending;
  return <span className={`px-2 py-0.5 rounded-full text-xs ${color}`}>{label}</span>;
};

const FuelRequestCard = ({ request, onClick }) => {
  const formatDate = (dateStr) => {
    return new Date(dateStr).toLocaleDateString('en-US', { 
      month: 'short', 
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  return (
    <div
      onClick={onClick}
      className="bg-gray-800/50 hover:bg-gray-800/70 active:bg-gray-700/60 rounded-xl border border-gray-700 p-3 cursor-pointer transition-all duration-200"
    >
      <div className="flex items-start justify-between">
        <div className="flex items-center gap-2">
          <div className="p-1.5 bg-orange-500/20 rounded-lg">
            <Fuel className="w-4 h-4 text-orange-400" />
          </div>
          <div>
            <p className="text-white font-medium text-sm">{request.quantity} gal</p>
            <p className="text-xs text-gray-500">{request.tail_number}</p>
          </div>
        </div>
        <StatusBadge status={request.status} />
      </div>

      {request.destination_icao && (
        <div className="flex items-center gap-1 mt-2 text-xs">
          <MapPin className="w-3 h-3 text-gray-500" />
          <span className="font-mono text-white">{request.destination_icao}</span>
        </div>
      )}

      <div className="flex items-center justify-between mt-2 pt-2 border-t border-gray-700/50">
        <div className="flex items-center gap-1 text-xs text-gray-500">
          <Calendar className="w-3 h-3" />
          {formatDate(request.scheduled_date)}
        </div>
        <ChevronRight className="w-4 h-4 text-gray-500" />
      </div>
    </div>
  );
};

export default FuelRequestCard;